import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Say Hi or Find me on other platforms: `}<a parentName="p" {...{
        "href": "https://github.com/Rehankhalil462"
      }}>{`Github`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.facebook.com/profile.php?id=100005126296510"
      }}>{`Facebook`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      